module.exports = {"440222100":"太平镇","440222101":"马市镇","440222102":"澄江镇","440222103":"顿岗镇","440222104":"罗坝镇","440222105":"司前镇","440222106":"隘子镇","440222107":"城南镇","440222108":"沈所镇","440222204":"深渡水乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440222.json
// module id = 1788
// module chunks = 0